import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { AspectRatioIcon } from "./AspectRatioIcon";
import { ASPECT_RATIOS } from "./constants";
import type { AspectRatioPickerProps } from "./types";

export function AspectRatioPicker({
  aspectRatio,
  onAspectRatioChange,
  className,
  availableRatios,
}: AspectRatioPickerProps) {
  const { t } = useLanguage();

  const ratios = availableRatios ?? ASPECT_RATIOS;

  const getDisplayLabel = (ratio: typeof ASPECT_RATIOS[number]) => {
    return ratio.label;
  };

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <h4 className="text-sm font-bold text-foreground mb-1">
        {t.generate.aspectRatio}
      </h4>
      <div className={cn(
        "grid gap-2",
        ratios.length <= 3 ? "grid-cols-3" : "grid-cols-5"
      )}>
        {ratios.map((ratio) => (
          <button
            key={ratio.id}
            onClick={() => onAspectRatioChange(ratio.id)}
            className={cn(
              "flex flex-col items-center justify-center p-2 rounded-xl transition-all border aspect-square",
              aspectRatio === ratio.id
                ? "bg-secondary border-foreground/30"
                : "bg-background border-border hover:border-foreground/30 hover:bg-secondary/50"
            )}
          >
            <AspectRatioIcon
              type={ratio.icon}
              className={cn(
                "mb-1",
                aspectRatio === ratio.id
                  ? "text-foreground"
                  : "text-muted-foreground"
              )}
            />
            <span
              className={cn(
                "text-[10px] font-medium",
                aspectRatio === ratio.id
                  ? "text-foreground"
                  : "text-muted-foreground"
              )}
            >
              {getDisplayLabel(ratio)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
